import { observable } from "mobx";
import { copy } from "../utils/data";

export class FAQ {
  @observable id:string;
  @observable category:string;
  @observable index:number;
  @observable lang: string;
  @observable order: number;
  @observable usage: number;
  @observable q: string;
  @observable a: string;

  constructor(faq: FAQ) {
    copy(faq, this);
  }
}

export class ContactRequest {
  @observable email: string;
  @observable reason: number;
  @observable lang: string;
  @observable message: string;
  constructor() {
      this.email = this.lang = this.message = "";
      this.reason = 0;
  }
}


// WEBPACK FOOTER //
// ./src/models/help.ts